import { JSXElement, lazy } from 'solid-js';
import { getSlug, EnvAppPaths } from '~/components/AppRouter/utils.ts';
import { Route } from '@solidjs/router';

export default function EnvAppPagesRoutes(): JSXElement {
  const Passkeys = lazy(
    () => import('~/pages/ExternalPages/EnvAppPages/Passkeys')
  );

  return (
    <Route path={getSlug.getEnvAppPagesBaseNamespace()}>
      <Route
        path={getSlug.envAppPages(EnvAppPaths.PASSKEYS)}
        component={Passkeys}
      />
    </Route>
  );
}
